import statusEnum from './widget/ListStatus/status.enum';

const useQualificationViewModel = ({ displayRequirementData }) => {
  const requirementData = (slug) => {
    if (Array.isArray(displayRequirementData)) {
      return displayRequirementData.find((item) => item.slug === slug);
    }
    return null;
  };

  const isDisplayRequirementData = (slug, data) => {
    if (data && Object.keys(data).length > 0 && Array.isArray(displayRequirementData)) {
      return displayRequirementData.some((item) => item.slug === slug && !item.position);
    }
    return false;
  };

  const isDisplayRequirementDataTop = (slug, data) => {
    if (data && Object.keys(data).length > 0 && Array.isArray(displayRequirementData)) {
      return displayRequirementData.some((item) => item.slug === slug && item.position === 'top');
    }
    return false;
  };

  const driverLicenseVerification = (data) => {
    const list = [];
    if (data) {
      for (var key in data) {
        const value = data[key];
        var type = statusEnum.NOT_PERFORMED;
        var label = '';
        // check if value is boolean or null
        if (key === 'approved') {
          type = value === null ? statusEnum.NOT_APPLICABLE : value;
          label = 'Manual Verification';
        } else if (typeof value === 'boolean' || value === null) {
          type =
            value === null
              ? statusEnum.NOT_PERFORMED
              : value
                ? statusEnum.PASSED
                : statusEnum.FAILED;
          const slug = key.replace(/_/g, ' ');
          label = String(slug).charAt(0).toUpperCase() + String(slug).slice(1);
        }
        list.push({
          label: label,
          type: type,
        });
      }
    }

    return list;
  };

  return {
    requirementData,
    isDisplayRequirementData,
    driverLicenseVerification,
    isDisplayRequirementDataTop,
  };
};

export default useQualificationViewModel;
